/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SuccessResponse as ModelsSuccessResponse } from '../../models/models/success-response';
import { TokenRequest as ModelsTokenRequest } from '../../models/models/token-request';

export interface ApiV1AuthActivateAccountPost$Params {
  
    /**
     * Activation token
     */
    body: ModelsTokenRequest
}

export function apiV1AuthActivateAccountPost(http: HttpClient, rootUrl: string, params: ApiV1AuthActivateAccountPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSuccessResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1AuthActivateAccountPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsSuccessResponse>;
    })
  );
}

apiV1AuthActivateAccountPost.PATH = '/api/v1/auth/activate-account';
